var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollarClassic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 137.53 81.33",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "titleId"
  }, "Your Title Here") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "titleId"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.81,82a10.34,10.34,0,0,1-.11-1.89c.42-14.59,29.6-38.76,42.35-48.89,4-3.23,14.54-9.25,4.21-16.49-17.14-17.56-77.92-17.46-97.44,0C10.5,22,21.14,28.1,25,31.22,37.78,41.46,66.75,65.52,67.38,80a13.47,13.47,0,0,1-.10,2Z",
    transform: "translate(-0.78 -0.72)",
    fill: "#404041"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9,14.72c-3,3,.28,13.27,4.23,16.45C38.38,41.79,69.5,67.59,67.22,81.78c0,0-23.59.56-41.21-7.52S2.41,54.53,1,52l9.23-34.72C50.44-4,90-5,128.83,17.46L138,52.05c-1.36,2.55-7.45,14.10-25.07,22.17s-41.18,7.53-41.18,7.53c-2.28-14.20,28.81-40,42.06-50.62,4-3.17,6.84-13.10,4.23-16.45C96.54-3.87,45.88-2.88,20.9,14.72Z",
    transform: "translate(-0.78 -0.72)",
    fill: "#fff",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollarClassic);
export default __webpack_public_path__ + "static/media/collar-classic.ceb834cb32c81145acb34e780c5af3ca.svg";
export { ForwardRef as ReactComponent };